export default __webpack_public_path__ + "43562b6332ac2bc38fb0a10bb440847c.svg";